import React, { Component, Context } from "react";
import { Text, Linking, StyleSheet, StyleProp, TextStyle, TouchableOpacity } from "react-native";
import { IPlatformContext, PlatformContext } from "../platform/context";
import NotificationsService from "../services/notifications";
import theme from "../theme";
import styles from "../styles";

export type HyperLinkProps = {
	title: string;
	url: string;
	notTargetBlank?: boolean;
	ignoreLinkCheck?: boolean;
	style?: StyleProp<any>;
	children?: React.ReactNode;
};

export default class HyperLink extends Component<HyperLinkProps> {
	static contextType: Context<IPlatformContext> = PlatformContext;

	render() {
		const renderer: typeof renderMobileHyperLink = this.context.renderHyperLink || renderMobileHyperLink;
		return renderer({
			...this.props,
			style: [this.props.style, styles.text.link],
		});
	}
}

export const renderMobileHyperLink = (props: HyperLinkProps) =>
	props.children ? (
		<TouchableOpacity onPress={() => openURL(props.url, props.ignoreLinkCheck)}>{props.children}</TouchableOpacity>
	) : (
		<Text style={props.style} onPress={() => openURL(props.url, props.ignoreLinkCheck)}>
			{props.title || props.url}
		</Text>
	);

function openURL(url: string, ignoreLinkCheck?: boolean) {
	if (ignoreLinkCheck) {
		Linking.openURL(url);
		return;
	}
	Linking.canOpenURL(url).then((supported) => {
		if (supported) {
			Linking.openURL(url);
		} else {
			console.log("Don't know how to open URI: " + url);
			NotificationsService.error(`Can't open link: ${url}`);
		}
	});
}
